import { render } from "./ProfilePicture.vue?vue&type=template&id=5664e76b"
import script from "./ProfilePicture.vue?vue&type=script&lang=js"
export * from "./ProfilePicture.vue?vue&type=script&lang=js"
script.render = render

export default script